// extracted by mini-css-extract-plugin
export default {"MessageWithIllustration":"MessageWithIllustration_MessageWithIllustration__5d9Qb","imageWrapper":"MessageWithIllustration_imageWrapper__qTZio"};